import VsCompare from "./VsCompare";

export default function VsFollowUpBoss() {
  return (
    <VsCompare
      competitor="Follow Up Boss"
      testId="vs-fub-page"
      slug="follow-up-boss"
      seoTitle="iKEY vs. Follow Up Boss — Built-in DocuSign & Free Tier"
      seoDescription="Compare iKEY and Follow Up Boss for solo real-estate agents. iKEY includes DocuSign and a free-forever tier — Follow Up Boss doesn't."
      tagline="Follow Up Boss stops at the contract. iKEY closes it."
      rows={[
        { label: "Free forever tier",             ikey: true,                    them: false },
        { label: "E-signatures included",         ikey: "DocuSign built-in",     them: "Bring your own DocuSign / dotloop" },
        { label: "Branded client portal",         ikey: true,                    them: false },
        { label: "AI 'Who to call today' briefing", ikey: true,                  them: "Basic follow-up reminders" },
        { label: "Native iOS + Android app",      ikey: true,                    them: true },
        { label: "Transaction deadline tracker",  ikey: true,                    them: "Third-party integration" },
        { label: "CSV data export on Free",       ikey: true,                    them: "No free tier" },
      ]}
      pricing={[
        { tier: "Free",             ikey: "$0 · 1–3 clients (CRM only)",     them: "No free tier" },
        { tier: "Entry paid tier",  ikey: "$39.99/mo · Growth · 10 clients", them: "$69/mo · Grow · 1 user" },
        { tier: "Mid-tier",         ikey: "$79.99/mo · Master · 20 clients",   them: "$497/mo · Pro · up to 10 users" },
        { tier: "Top tier",         ikey: "$119.99/mo · Pro · unlimited",    them: "$1,000+/mo · Platform" },
        { tier: "DocuSign add-on",  ikey: "Included in every paid plan",     them: "$45–$85/mo extra (DocuSign)" },
      ]}
      chooseIkeyWhen={[
        "You're a solo agent or a small book — Follow Up Boss's $497/mo Pro tier is priced for teams of 10, not one.",
        "You want e-signatures without a second subscription — iKEY has DocuSign built into every paid plan.",
        "You want a branded client-facing portal, not just an internal CRM — clients see your face and brokerage colors from day one.",
        "You need to start free — iKEY's Free tier gives you a real CRM for your first three clients, no card required.",
        "You'd rather work from your phone than a desk — iKEY's mobile-first Run-My-Day view is the primary surface, not an afterthought.",
      ]}
      faq={[
        {
          q: "Can I migrate my Follow Up Boss data into iKEY?",
          a: "Yes. Export your leads and clients from Follow Up Boss as CSV, then use iKEY's Import CSV button on the Leads page to bring them across. Notes and tags map automatically.",
        },
        {
          q: "Does iKEY have Follow Up Boss's team collaboration features?",
          a: "iKEY is single-user by design — every plan is for one agent. If you run a multi-agent team, iKEY isn't the fit today. If you're a solo agent, that's the whole point: no seat math, no admin.",
        },
        {
          q: "Is iKEY's DocuSign the real DocuSign?",
          a: "Yes. iKEY uses the DocuSign API under the hood — same signed-envelope certificates, same audit trail, same legal enforceability. You just don't pay for or log into DocuSign separately.",
        },
        {
          q: "How much cheaper is iKEY over a year?",
          a: "Follow Up Boss Grow ($69/mo) plus DocuSign Standard ($45/mo) is about $1,368/year. iKEY Growth is $479.88/year — around $888 saved. Annual billing on iKEY drops that another 18%.",
        },
      ]}
    />
  );
}
